import React, { useMemo, useState } from 'react';
import { Dropdown, Button, Typography } from '@duxton-web/ui';
import { ChevronDownUniversal } from '@duxton-web/icons';
import {
  colorOutlineDefault,
  colorContentSubtle,
} from '@duxton-web/design-tokens/themes/light';
import './SingleSelect.scss';

interface Option {
  label: string;
  value: string;
}

interface Props {
  onChange: (value?: string) => void;
  title?: string;
  placeholder: string;
  initialValue?: string;
  value?: string; // Add value prop for controlled component
  options: Option[];
  width?: string;
  height?: string;
  addNone?: boolean;
}

const ALL = 'All';

const SingleSelect: React.FC<Props> = (props) => {
  const [internalChosen, setInternalChosen] = useState<string | undefined>(props.initialValue);
  
  // Use value prop if provided (controlled), otherwise use internal state (uncontrolled)
  const chosen = props.value !== undefined ? props.value : internalChosen;
  
  const options = props.addNone
    ? [{ label: ALL, value: ALL }, ...props.options]
    : props.options;

  const handleMenuSelect = (value: { key: string }) => {
    const selectedMenu = value.key === ALL ? undefined : value.key;
    
    // Only update internal state if not controlled
    if (props.value === undefined) {
      setInternalChosen(selectedMenu);
    }
    
    props.onChange(selectedMenu);
  };

  const selectedOptionLabel = useMemo(() => {
    const selectedOption = options.find(option => option.value === chosen);

    return selectedOption ? selectedOption.label : props.placeholder;
  }, [chosen, options, props.placeholder]);

  return (
    <div>
      {props.title ?
        <div style={{ margin: '5px 2px', fontWeight: 600, width: props.width }}>
          {props.title}
        </div> : ''
      }

      <Dropdown
        trigger={['click']}
        menu={{
          selectable: true,
          items: options.map((menuItem) => ({
            key: menuItem.value,
            value: menuItem.value,
            label: menuItem.label,
          })),

          onClick: handleMenuSelect,
        }}
      >
        <Button
          style={{
            fontWeight: 400,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: props.width,
            height: props.height,
            borderColor: colorOutlineDefault,
            color: colorContentSubtle,
          }}
        >
          <Typography.Body ellipsis level={3}>
            {selectedOptionLabel}
          </Typography.Body>
          <ChevronDownUniversal />
        </Button>
      </Dropdown>
    </div>
  );
};

export default SingleSelect;
